/**
 * 앱 브릿지 테스트 페이지
 * - 환경 정보 — 우측 상단 작은 버튼 → 툴팁
 * - 디버그로그 on/off — 우측 상단 버튼 ($j.Ui.DebugLog: 브로커 송수신을 화면 칩으로).
 *   세션 유지라 이 페이지를 떠나도 계속 켜져 있다 → 버튼 라벨/색으로 현재 상태를 보여준다
 * - 탭: [도메인설정] 앱이 접속할 호스트 교체 (changeHost — 수락되면 앱이 새 호스트로 재진입)
 *      [앱함수 테스트] 아래 select → 실행 흐름
 * - 앱 함수 select → 실행 → 단일 결과 패널 갱신
 *   * 처리 경로 (appBroker 수락 / 거부 / WEB) 표시
 *   * 즉시 반환값 표시
 *   * 기대 콜백 안내
 *   * 콜백 도착 시 패널 하단에 누적 표시
 * - 새 실행 시 기존 결과는 갱신되어 사라짐 (해당 함수 결과만)
 */
import AppHosts from '../../F/AppHosts';

export default class DevBridge {
    constructor() {
        // 앱이 접속할 수 있는 도메인 — 정본은 F/AppHosts
        this._hosts = AppHosts;

        this._actions = [
            // [정보]
            { key:'getPhoneNumber',    label:'getPhoneNumber()',                         group:'정보',     expects:'callbackPhoneNumber' },
            { key:'getDeviceContext',  label:'getDeviceContext()',                       group:'정보',     expects:'callbackDeviceContext' },
            { key:'getDebugLog',       label:"getDebugLog('app')",                       group:'정보',     expects:null },

            // [권한] — 액션 미구현 앱이면 즉시반환 null / false
            { key:'getLocationPermission',     label:'getLocationPermission()',          group:'권한',     expects:null },
            { key:'requestLocationPermission', label:'requestLocationPermission()',      group:'권한',     expects:'callbackLocationPermission' },

            // [사운드 / TTS]
            { key:'playSound',         label:"playSound('cock_a_doodle_doo')",           group:'사운드/TTS', expects:null },
            { key:'readTts',           label:"readTts('테스트입니다')",                    group:'사운드/TTS', expects:null },

            // [STT]
            { key:'listenStartVoice',  label:"listenStartVoice('directinput','listMemoregistext','말씀하세요',1)", group:'STT', expects:'callbackSpeechResult' },
            { key:'listenEndVoice',    label:'listenEndVoice()',                         group:'STT',      expects:null },

            // [외부 연동]
            { key:'shareFile',         label:"shareFile('/img/icon.png')", group:'외부', expects:null },
            { key:'downloadImage',     label:"downloadImage('/img/icon.png')", group:'외부', expects:null },
            { key:'runNavi',           label:'runNavi(127.0276, 37.4979, "테헤란로")',    group:'외부',     expects:null },
            { key:'openRoadView',      label:"openRoadView('37.4979,127.0276')",         group:'외부',     expects:null },
            { key:'openPlaystore',     label:'openPlaystore()',                          group:'외부',     expects:null },
            { key:'devilAppSupported', label:'devilAppSupported()  → getCapabilities.openApp', group:'외부', expects:null },
            { key:'devilAppInstalled', label:'devilAppInstalled()  → openApp check:1 (true|false|null)', group:'외부', expects:null },
            { key:'openDevilApp',      label:"openDevilApp()  → 앱 열기 ('opened'|'none'|false)", group:'외부', expects:null },
            { key:'openDevilAppWeb',   label:"openDevilApp({fallback:'/devil-install'})  → 미설치면 브라우저", group:'외부', expects:null },
            { key:'openAddressBook',   label:'openAddressBook()',                        group:'외부',     expects:'callbackAddressBook' },
            { key:'runSocialN',        label:"runSocial('naver')",                       group:'외부',     expects:'callbackSocialResult' },
            { key:'runSocialK',        label:"runSocial('kakao')",                       group:'외부',     expects:'callbackSocialResult' },

            // [사진] — 레거시 폴백 없음. 구앱은 ok:0 (false)
            { key:'listPhotos',           label:'listPhotos({limit:30})',                group:'사진',     expects:'callbackPhotos' },
            { key:'listPhotosReselect',   label:'listPhotos({reselect:true})',            group:'사진',     expects:'callbackPhotos (권한창 → 첫 페이지)' },
            { key:'listPhotosToday',      label:'listPhotos({since:오늘 00:00})',         group:'사진',     expects:'callbackPhotos (did 로 구간 확인)' },
            { key:'uploadSelectedPhotos', label:"uploadSelectedPhotos('diary1', ORDER, [token])", group:'사진', expects:'callbackUploadImage' },

            // [설정]
            { key:'syncMySettings',    label:'syncMySettings()',                         group:'설정',     expects:null },
            { key:'setPopUpConfig',    label:'setPopUpConfig(true)',                     group:'설정',     expects:'callbackChannelCount' },
            { key:'webviewHealthCheck',label:'webviewHealthCheck()',                     group:'설정',     expects:null },
        ];
    }

    initialize() {
        // Social 모듈의 후속 처리(ajax/_end/swalert/페이지 이동) 차단 — DevBridge 에서는 native 반환값만 확인.
        // 페이지 떠날 때까지 유지됨 (SPA 가 아니므로 재로드 시 자동 false 로 초기화).
        if ($j.F.Social) $j.F.Social.suppressed = true;

        this._bindEnv();
        this._bindDebugLog();
        this._bindTabs();
        this._buildHostSelect();
        this._bindHostApply();
        this._buildActionSelect();
        this._bindRun();
        this._hookBrokerCallbacks();
        this._hookEventBus();
    }

    /* =========================
     * 환경 정보 — 우측 상단 버튼 → 툴팁
     * ========================= */

    _bindEnv = () => {
        // 값은 로드 시점 스냅샷이 아니라 누를 때마다 다시 읽는다 (Social.suppressed 등이 도중에 바뀜)
        $('#dev-env-btn').on('click', (e) => {
            $j.Ui.Tooltip.show(e.currentTarget, this._envHtml(), { title: '환경 정보' });
        });
    }

    _envHtml = () => {
        const isApp   = $j.F.App.isApp();
        const ver     = $j.F.App.getVersion();
        const pkg     = $j.F.App.getPackage();
        const mbNo    = (typeof MEMBER !== 'undefined' && MEMBER['num']) || '?';
        const driver  = (typeof MEMBER !== 'undefined' && MEMBER['mem_driver_type']) || '?';
        const ns      = (typeof G5 !== 'undefined' && G5['NS']) || '?';

        const socialSup = $j.F.Social && $j.F.Social.suppressed ? 'ON (후속 처리 차단)' : 'OFF';

        return '<div class="dev-info">'
            + `<b>Android.isApp():</b> ${isApp}\n`
            + `<b>Android.getVersion():</b> ${ver}\n`
            + `<b>Android.getPackage():</b> ${pkg}\n`
            + `<b>location.origin:</b> ${location.origin}\n`
            + `<b>MEMBER['num']:</b> ${mbNo}\n`
            + `<b>MEMBER['mem_driver_type']:</b> ${driver}\n`
            + `<b>G5['NS']:</b> ${ns}\n`
            + `<b>Social.suppressed:</b> ${socialSup}\n`
            + `<b>UA:</b> ${this._escape(navigator.userAgent)}`
            + '</div>';
    }

    /* =========================
     * 디버그로그 on/off — $j.Ui.DebugLog (브로커 송수신 화면 칩)
     * ========================= */

    _bindDebugLog = () => {
        this._syncDebugBtn();
        $('#dev-dbg-btn').on('click', () => {
            const next = !$j.Ui.DebugLog.enabled;
            $j.Ui.DebugLog.enabled = next;   // 세션에 남는다 — 페이지를 옮겨도 유지
            this._syncDebugBtn();
            // 켠 직후엔 칩이 실제로 뜨는지 바로 보여준다 (끌 때는 이미 전부 사라진 뒤라 생략)
            if (next) $j.Ui.DebugLog.push('디버그로그 ON', ['앱 브로커 송수신을 화면에 표시합니다'], { kind: 'info' });
            else $j.Ui.Toast.show('디버그로그 OFF');
        });
    }

    /** 버튼 라벨·색을 현재 상태에 맞춘다 (세션 유지라 재진입 시에도 켜져 있을 수 있다) */
    _syncDebugBtn = () => {
        const on = !!($j.Ui.DebugLog && $j.Ui.DebugLog.enabled);
        $('#dev-dbg-btn').toggleClass('is-on', on).text(on ? '🐞 디버그로그 ON' : '🐞 디버그로그 OFF');
    }

    /* =========================
     * 탭 전환
     * ========================= */

    _bindTabs = () => {
        $('.dev-tab').on('click', function() {
            const tab = $(this).data('tab');
            $('.dev-tab').removeClass('is-on');
            $(this).addClass('is-on');
            $(".dev-pane").each((i, el) => { el.hidden = el.dataset.pane !== tab; });
        });
    }

    /* =========================
     * 도메인 설정 — changeHost
     * ========================= */

    _buildHostSelect = () => {
        const origin = location.origin;
        $('#dev-host-current').text(origin);

        let html = '<option value="">— 선택하세요 —</option>';
        this._hosts.forEach((h, i) => {
            const isNow = (h.host === origin);
            html += `<option value="${i}"${isNow ? ' selected' : ''}>`
                 +  `${this._escape(h.host)} (${this._escape(h.tag)})${isNow ? ' ← 현재' : ''}`
                 +  `</option>`;
        });
        const self = this;
        $('#dev-host-select').html(html).on('change', function() {
            const h = self._pickedHost();
            $('#dev-host-meta').html(h
                ? `전송: action=<b>changeHost</b>, data=${self._escape(JSON.stringify({ host: h.host, tag: h.tag }))}`
                : '도메인을 선택하세요');
        }).trigger('change');
    }

    _pickedHost = () => {
        const idx = $('#dev-host-select').val();
        return idx === '' || idx === null ? null : this._hosts[Number(idx)];
    }

    _bindHostApply = () => {
        $('#dev-host-apply').on('click', () => {
            const h = this._pickedHost();
            if (!h) { alert('도메인을 선택하세요'); return; }
            if (h.host === location.origin && !confirm(`이미 ${h.tag} 도메인입니다. 그대로 적용할까요?`)) return;
            if (!confirm(`앱 접속 도메인을 아래로 변경합니다.\n\n${h.host}  (${h.tag})`)) return;

            // 수락되면 앱이 곧바로 새 호스트로 재진입하므로 이 페이지는 사라진다 —
            // 결과 패널을 둘 자리가 없어 실패했을 때만 토스트로 알린다.
            // 앱 외 환경은 runAppBroker 가 이미 alert 를 띄우므로 토스트 생략
            if (!$j.F.App.changeHost(h.host, h.tag) && $j.F.App.isApp()) {
                $j.Ui.Toast.show('앱이 changeHost 를 처리하지 않았습니다 (구앱·미구현 또는 웹 환경)', { type: 'error' });
            }
        });
    }

    /* =========================
     * 액션 select 빌드 + change 시 메타 표시
     * ========================= */

    _buildActionSelect = () => {
        const $sel = $('#dev-action-select');
        const groups = {};
        this._actions.forEach(a => {
            (groups[a.group] = groups[a.group] || []).push(a);
        });

        let html = '<option value="">— 선택하세요 —</option>';
        Object.keys(groups).forEach(g => {
            html += `<optgroup label="[ ${g} ]">`;
            groups[g].forEach(a => {
                html += `<option value="${a.key}">${this._escape(a.label)}</option>`;
            });
            html += `</optgroup>`;
        });
        $sel.html(html);

        const self = this;
        $sel.on('change', function() {
            const key = $(this).val();
            const $meta = $('#dev-action-meta');
            if (!key) { $meta.text('함수를 선택하세요'); return; }
            const a = self._actions.find(x => x.key === key);
            if (a.expects) {
                $meta.html(`기대 콜백: <b>${self._escape(a.expects)}</b>`);
            } else {
                $meta.html('콜백 없음 (즉시 반환값만 확인)');
            }
        });
    }

    /* =========================
     * 실행 버튼
     * ========================= */

    _bindRun = () => {
        $('#dev-run').on('click', () => {
            const key = $('#dev-action-select').val();
            if (!key) { alert('함수를 선택하세요'); return; }
            const a = this._actions.find(x => x.key === key);
            this._runAction(a);
        });
    }

    /** 브로커 송신 경로를 후킹한 채 호출 실행 → 결과 패널 갱신. */
    _runAction = (a) => {
        const hasBroker = !!(window.App && typeof App.appBroker === 'function');

        // ── Hook 1: runAppBroker — 일반 JS 메서드라 확실히 후킹 가능 (주 진단 수단)
        let brokerCalled = false;
        let brokerReturn = null;   // runAppBroker boolean
        const origRunBroker = $j.F.App.runAppBroker;
        $j.F.App.runAppBroker = function(action, data, callback) {
            brokerCalled = true;
            brokerReturn = origRunBroker.call(this, action, data, callback);
            return brokerReturn;
        };

        // ── Hook 1-b: callBroker — 레거시 없는 신규 액션은 runAppBroker 를 거치지 않고 여기로 송신
        //    (runAppBroker 도 내부적으로 callBroker 를 타므로, 그 경우엔 Hook 1 이 뒤에 덮어씀 — 값은 동일)
        const origCallBroker = $j.F.App.callBroker;
        $j.F.App.callBroker = function(action, data, callback) {
            brokerCalled = true;
            const res = origCallBroker.call(this, action, data, callback);
            brokerReturn = (res.ok == 1);
            return res;
        };

        // ── Hook 2: App.appBroker — host 객체라 silently 실패할 수 있음, best-effort
        //    성공 시 native return 값(1/0)까지 알 수 있어 부가 정보로만 사용
        let nativeReturn = null;
        let origAppBroker;
        if (hasBroker) {
            origAppBroker = window.App.appBroker;
            try {
                window.App.appBroker = function(json) {
                    nativeReturn = origAppBroker.call(window.App, json);
                    return nativeReturn;
                };
            } catch (e) { /* host 객체 — 무시 */ }
        }

        // ── 함수 호출
        let result, error = null;
        try {
            result = this._invoke(a.key);
        } catch (err) {
            error = err;
            console.error(err);
        } finally {
            // restore — runAppBroker/callBroker 는 인스턴스 own property 였으므로 delete 로 prototype 복귀
            delete $j.F.App.runAppBroker;
            delete $j.F.App.callBroker;
            if (hasBroker) {
                try { window.App.appBroker = origAppBroker; } catch (e) {}
            }
        }

        // ── 처리 경로 결정
        let path, pathClass;
        if (!hasBroker) {
            path = 'WEB (앱 환경 아님)';
            pathClass = 'path-none';
        } else if (!brokerCalled) {
            path = '브로커 호출 안 함 (직접 분기 또는 동기 메서드)';
            pathClass = 'path-none';
        } else if (brokerReturn === true) {
            path = (nativeReturn !== null)
                ? `✓ appBroker 처리됨 (native return ${nativeReturn})`
                : '✓ appBroker 처리됨';
            pathClass = 'path-broker';
        } else {
            path = (nativeReturn !== null)
                ? `⚠ appBroker 거부 (native return ${nativeReturn}) — 앱 미구현 액션`
                : '⚠ appBroker 거부 — 앱 미구현 액션';
            pathClass = 'path-legacy';
        }

        this._renderResult({ action: a.label, path, pathClass, result, error, expects: a.expects });
    }

    _invoke = (key) => {
        const A = $j.F.App;
        switch (key) {
            // 정보
            case 'getPhoneNumber':    return A.getPhoneNumber();
            case 'getDeviceContext':  return A.getDeviceContext();
            case 'getDebugLog':       return A.getDebugLog('app');

            // 권한 (즉시 반환 — getLocationPermission 은 1/0/null)
            case 'getLocationPermission':     return A.getLocationPermission();
            case 'requestLocationPermission': return A.requestLocationPermission();

            // 사운드 / TTS
            case 'playSound':         return A.playSound('cock_a_doodle_doo');
            case 'readTts':           return A.readTts('테스트입니다');

            // STT
            case 'listenStartVoice':  return A.listenStartVoice('directinput', 'listMemoregistext', '말씀하세요', 1);
            case 'listenEndVoice':    return A.listenEndVoice();

            // 외부
            case 'shareFile':         return A.shareFile('/img/icon.png');
            case 'downloadImage':     return A.downloadImage('/img/icon.png');
            case 'runNavi':           return A.runNavi(127.0276, 37.4979, '테헤란로');
            case 'openRoadView':      return A.openRoadView('37.4979,127.0276');
            case 'openPlaystore':     return A.openPlaystore();
            case 'devilAppSupported': return A.devilAppSupported();
            case 'devilAppInstalled': return A.devilAppInstalled();
            case 'openDevilApp':      return A.openDevilApp();
            case 'openDevilAppWeb':   return A.openDevilApp({ fallback: location.origin + '/devil-install' });
            case 'openAddressBook':   return A.openAddressBook();
            case 'runSocialN':        return A.runSocial('naver');
            case 'runSocialK':        return A.runSocial('kakao');

            // 사진 (그리드 피커) — uploadSelectedPhotos 는 직전 listPhotos 가 준 첫 token 으로 시험
            case 'listPhotos':         return A.listPhotos({ limit: 30 });
            case 'listPhotosReselect': return A.listPhotos({ reselect: true });
            case 'listPhotosToday': {
                const d = new Date();
                const ymd = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                return A.listPhotos({ since: `${ymd} 00:00:00` });
            }
            case 'uploadSelectedPhotos': {
                const ordernum = (typeof ORDER !== 'undefined' && ORDER['num']) || null;
                const tokens = (this._photoTokens || []).slice(0, 1);
                if (!tokens.length) $j.Ui.Toast.show('warning', '먼저 listPhotos 를 실행해 token 을 받으세요');
                return A.uploadSelectedPhotos('diary1', ordernum, tokens);
            }

            // 설정
            case 'syncMySettings':    return $j.F.JbApp.syncMySettings();
            case 'setPopUpConfig':    return A.setPopUpConfig(true);
            case 'webviewHealthCheck':return A.webviewHealthCheck();
        }
    }

    /* =========================
     * 결과 패널 렌더링
     * ========================= */

    _renderResult = ({ action, path, pathClass, result, error, expects }) => {
        let html = `<div class="dev-result-call">▶ ${this._escape(action)}</div>`;
        html += `<div class="dev-result-row">
                    <span class="dev-result-label">처리 경로</span>
                    <span class="dev-result-value ${pathClass}">${this._escape(path)}</span>
                 </div>`;

        if (error) {
            html += `<div class="dev-result-err">✗ 에러: ${this._escape(error.message || String(error))}</div>`;
        } else {
            html += `<div class="dev-result-row">
                        <span class="dev-result-label">즉시 반환</span>
                        <span class="dev-result-value">${this._escape(this._fmt(result))}</span>
                     </div>`;
        }

        html += `<div class="dev-result-row">
                    <span class="dev-result-label">기대 콜백</span>
                    <span class="dev-result-value">${expects ? this._escape(expects) : '— 없음'}</span>
                 </div>`;

        // 콜백 도착 시 누적될 영역
        html += `<div class="dev-cb-area" id="dev-cb-area"></div>`;

        $('#dev-result').html(html);
    }

    /* =========================
     * 응답 후킹 — broker 콜백
     *
     * Android → callbackBroker → $j.F.App.callbackXxx(data) → BROKER 표시
     * (레거시 글로벌 후킹은 2026-08 제거 — 웹에 레거시 진입점이 남아있지 않다.)
     * ========================= */

    _hookBrokerCallbacks = () => {
        const BROKER_CBS = [
            'callbackPhoneNumber',
            'callbackDeviceContext',
            'callbackSpeechResult',
            'callbackSocialResult',
            'callbackUploadImage',
            'callbackAddressBook',
            'callbackChannelCount',
            'callbackLocationPermission',
            'callbackPhotos',
        ];
        const A = $j.F.App;
        const self = this;
        BROKER_CBS.forEach(name => {
            const orig = A[name];
            if (typeof orig !== 'function') return;
            A[name] = function(data) {
                // 최근사진은 썸네일 base64 가 커서 그대로 찍으면 패널을 덮는다 — 요약만 표시하고 token 은 stash
                if (name === 'callbackPhotos') {
                    const items = (data && Array.isArray(data.items)) ? data.items : [];
                    self._photoTokens = items.map(i => i && i.token).filter(Boolean);
                    self._onCall('BROKER', name, [{
                        status: data && data.status,
                        permission: data && data.permission,
                        items: `${items.length}건`,
                        cursor: data && data.cursor,
                        hasMore: data && data.hasMore,
                    }]);
                } else {
                    self._onCall('BROKER', name, [data]);
                }
                return orig.call(A, data);
            };
        });
    }

    /**
     * EventBus 후킹 — broker 콜백 훅으로 안 잡히는 파생/하류 이벤트용 백업 채널.
     * social 흐름은 콜백(callbackSocialResult) 과 EventBus(app:social:result, social:complete)
     * 양쪽으로 추적 — 한쪽 훅이 실패해도 다른 쪽이 받쳐줌.
     */
    _hookEventBus = () => {
        const EVENTS = [
            'app:social:result',  // 소셜 인증 raw 결과 ({res, token, sns_type}) — 콜백 훅 누락 시 백업
            'social:complete',        // 소셜 인증 최종 분기 데이터 ({result, next, info, message})
        ];
        const self = this;
        EVENTS.forEach(name => {
            $j.Common.EventBus.on('$j.F.DevBridge', name, (e, data) => {
                self._onCall('EVENT', name, [data]);
            });
        });
    }

    _onCall = (kind, name, args) => {
        const $cb = $('#dev-cb-area');
        if (!$cb.length) return;
        const ts = new Date().toLocaleTimeString('ko-KR', { hour12: false });
        const argsStr = args.map(a => {
            if (a === undefined) return 'undefined';
            if (a === null)      return 'null';
            if (typeof a === 'string') return `'${a}'`;
            if (typeof a === 'object') { try { return JSON.stringify(a); } catch (e) { return '[obj]'; } }
            return String(a);
        }).join(', ');
        const cls = 'dev-cb-event';
        const item = `<div class="dev-cb-item ${cls}">
                        <span class="ts">${ts}</span>
                        <span class="ev">◀ ${kind}  ${this._escape(name)}(${this._escape(argsStr)})</span>
                      </div>`;
        $cb.append(item);
    }

    /* =========================
     * 유틸
     * ========================= */

    _fmt = (r) => {
        if (r === undefined) return 'undefined';
        if (r === null)      return 'null';
        if (typeof r === 'boolean' || typeof r === 'number' || typeof r === 'string') return String(r);
        try { return JSON.stringify(r); } catch (e) { return '[unserializable]'; }
    }

    _escape = (s) => String(s).replace(/[&<>]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;' })[c]);
}
